import React, { forwardRef } from 'react';
import { ButtonBaseProps } from './types';
import clsx from 'clsx';

const ButtonBase = forwardRef<HTMLElement, ButtonBaseProps>(function ButtonBase(
  props,
  ref
) {
  // Apply Default props values
  props = {
    ...{
      as: 'button'
    },
    ...props
  };

  const { href, className, as, children, ...rest } = props;

  const ComponentTag = href ? 'a' : as || 'button';

  const cls = styleButtonBase(props);

  return (
    <ComponentTag
      className={clsx(cls.main, className)}
      href={href}
      ref={ref}
      {...rest}
    >
      {children}
    </ComponentTag>
  );
});

export default ButtonBase;

function styleButtonBase(props: ButtonBaseProps) {
  const mc = 'ButtonBase';
  const cls = {
    main: [mc]
  };
  return cls;
}
